export const handleKeyDownForNumberOnly = (
  e: React.KeyboardEvent<HTMLInputElement>
) => {
  // Prevent entry of non-numeric characters including 'e', '-', and '.'
  if (
    !/[0-9]/.test(e.key) &&
    e.key !== 'Backspace' &&
    e.key !== 'ArrowLeft' &&
    e.key !== 'ArrowRight' &&
    e.key !== 'Delete'
  ) {
    e.preventDefault();
  }
};
